import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import HomeIcon from '@mui/icons-material/Home';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import BuildIcon from '@mui/icons-material/Build';
import CaseIcon from '@mui/icons-material/BusinessCenter';
import ArticleIcon from '@mui/icons-material/Article';
import Container from '@mui/material/Container';
// Temporarily comment out auth-related imports
// import Avatar from '@mui/material/Avatar';
// import Menu from '@mui/material/Menu';
// import MenuItem from '@mui/material/MenuItem';
// import Divider from '@mui/material/Divider';
// import PersonIcon from '@mui/icons-material/Person';
// import LogoutIcon from '@mui/icons-material/Logout';
// import { useAuth } from '../../context/AuthContext';

const Header = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  // const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  // Temporarily comment out auth-related variables
  // const { currentUser, userProfile, logout } = useAuth();
  // const navigate = useNavigate();

  const navItems = [
    { title: 'Home', path: '/', icon: <HomeIcon /> },
    { title: 'Q&A', path: '/qanda', icon: <QuestionAnswerIcon /> },
    { title: 'Tools', path: '/tools', icon: <BuildIcon /> },
    { title: 'Case Studies', path: '/case-studies', icon: <CaseIcon /> },
    { title: 'Blog', path: '/blog', icon: <ArticleIcon /> }
  ];

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  // Temporarily comment out auth-related functions
  // const handleMenuOpen = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleMenuClose = () => {
  //   setAnchorEl(null);
  // };

  // const handleLogout = async () => {
  //   try {
  //     await logout();
  //     handleMenuClose();
  //     navigate('/');
  //   } catch (error) {
  //     console.error('Failed to log out', error);
  //   }
  // };

  const drawer = (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <Box sx={{ p: 2, borderBottom: `1px solid ${theme.palette.divider}` }}>
        <Typography variant="h6" color="primary" fontWeight="bold">
          ScrumTherapist
        </Typography>
      </Box>
      <List>
        {navItems.map((item) => (
          <ListItem button key={item.title} component={Link} to={item.path}>
            <ListItemIcon>
              {item.icon}
            </ListItemIcon>
            <ListItemText primary={item.title} />
          </ListItem>
        ))}
      </List>
      {/* Temporarily comment out auth-related UI
      <Divider />
      {currentUser ? (
        <List>
          <ListItem button component={Link} to="/profile">
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            <ListItemText primary="My Profile" />
          </ListItem>
          <ListItem button onClick={handleLogout}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="Sign Out" />
          </ListItem>
        </List>
      ) : (
        <List>
          <ListItem button component={Link} to="/signin">
            <ListItemText primary="Sign In" />
          </ListItem>
          <ListItem button component={Link} to="/signup">
            <ListItemText primary="Sign Up" />
          </ListItem>
        </List>
      )}
      */}
    </Box>
  );

  return (
    <AppBar position="sticky" color="primary" elevation={0} sx={{ 
      borderBottom: `1px solid ${theme.palette.divider}`,
      background: 'linear-gradient(90deg, #043947 0%, #043947 100%)'
    }}>
      <Container maxWidth="lg">
        <Toolbar sx={{ py: 1 }}>
          {isMobile && (
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleDrawer(true)}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Typography 
            variant="h5" 
            component={Link} 
            to="/" 
            sx={{ 
              flexGrow: 1, 
              textDecoration: 'none', 
              color: 'white',
              fontWeight: 'bold',
              letterSpacing: '0.5px',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Box 
              component="img"
              src={`${process.env.PUBLIC_URL}/images/logo.png`}
              alt="ScrumTherapist Logo"
              sx={{ 
                mr: 1, 
                height: 40,
                width: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            />
            ScrumTherapist
          </Typography>
          {!isMobile && (
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              {navItems.map((item) => (
                <Button 
                  color="primary.dark" 
                  key={item.title} 
                  component={Link} 
                  to={item.path}
                  sx={{ 
                    px: 2,
                    py: 1,
                    borderRadius: 2,
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 0.1)'
                    }
                  }}
                  startIcon={item.icon}
                >
                  {item.title}
                </Button>
              ))}
              
              {/* Temporarily comment out auth-related UI
              {currentUser ? (
                <>
                  <IconButton 
                    onClick={handleMenuOpen}
                    sx={{ ml: 2 }}
                  >
                    <Avatar 
                      src={currentUser.photoURL || ''}
                      alt={userProfile?.displayName || currentUser.email}
                      sx={{ width: 40, height: 40 }}
                    >
                      {userProfile?.displayName?.charAt(0) || currentUser.email?.charAt(0) || 'U'}
                    </Avatar>
                  </IconButton>
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                    PaperProps={{
                      elevation: 3,
                      sx: { minWidth: 180 }
                    }}
                  >
                    <MenuItem onClick={() => { handleMenuClose(); navigate('/profile'); }}>
                      <ListItemIcon>
                        <PersonIcon fontSize="small" />
                      </ListItemIcon>
                      My Profile
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={handleLogout}>
                      <ListItemIcon>
                        <LogoutIcon fontSize="small" />
                      </ListItemIcon>
                      Sign Out
                    </MenuItem>
                  </Menu>
                </>
              ) : (
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Button 
                    component={Link} 
                    to="/signin"
                    variant="outlined"
                    sx={{ 
                      color: 'white', 
                      borderColor: 'white',
                      '&:hover': {
                        borderColor: 'white',
                        backgroundColor: 'rgba(255, 255, 255, 0.1)'
                      }
                    }}
                  >
                    Sign In
                  </Button>
                  <Button 
                    component={Link} 
                    to="/signup"
                    variant="contained"
                    sx={{ 
                      backgroundColor: 'white',
                      color: 'primary.main',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.9)'
                      }
                    }}
                  >
                    Sign Up
                  </Button>
                </Box>
              )}
              */}
            </Box>
          )}
        </Toolbar>
      </Container>
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
      >
        {drawer}
      </Drawer>
    </AppBar>
  );
};

export default Header;